import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { Roles } from '../../models/commonmodel';
import { AgePipe } from "../shared/pipes/age.pipe";
import { MatMenuModule } from '@angular/material/menu';
import { EntityType } from '../shared/share';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddPatientComponent } from '../add-patient/add-patient.component';
import { FillExtraInfoComponent } from '../fill-extra-info/fill-extra-info.component';
import { PatientProfileComponent } from '../patient-profile/patient-profile.component';
import { RequestMedicalEvidenceComponent } from '../request-medical-evidence/request-medical-evidence.component';
import { RequestMoreDetailsComponent } from '../request-more-details/request-more-details.component';
import { SubmitMedicalEvidenceComponent } from '../submit-medical-evidence/submit-medical-evidence.component';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationService } from '../shared/services/notifications.service';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { InitialsPipe } from '../shared/pipes/intials.pipe';

@Component({
  selector: 'app-member-card',
  standalone: true,
  imports: [CommonModule, AgePipe, MatMenuModule, FormsModule, MatFormFieldModule, MatInputModule,
    MatRadioModule, MatTooltipModule,InitialsPipe
  ],
  templateUrl: './member-card.component.html',
  styleUrl: './member-card.component.scss'
})
export class MemberCardComponent {

  @Input() row: any;
  enumRole = Roles;
  enumEntityType = EntityType;
  selectedPatient: any; // You can type this more strictly if needed
  userId = this.memberService.getLoginUserId();

  constructor(public memberService: MemberInsurerServiceService, private dialog: MatDialog, private notificationService: NotificationService,
    private restService: MemberInsurerRestService
  ) {
  }

  ngOnInit() {
    // Initialization logic if needed
    console.log('MemberCardComponent initialized', this.row);

  }

  searchQuery: string = '';
  selectedUser: any = null;

  userList: any[] = [];

  filteredUsers() {
    const q = this.searchQuery.toLowerCase();
    return this.userList.filter(
      u =>
        u.firstName.toLowerCase().includes(q) ||
        u.lastName.toLowerCase().includes(q) ||
        u.phone.includes(q)
    );
  }

  selectUser(user: any): void {
    if (this.selectedUser === user.userId) {
      this.restService.addProviderAgentToRequest(this.openedRowId, user.userId).subscribe(
        (res: string) => {
          this.notificationService.showNotification('Agent Deassigned successfully'); // Use the plain text message
          this.memberService.emitRefresh();
        },
        err => {
          this.notificationService.showNotification(err.error.message || 'Something went wrong', 'error');
          this.selectedUser = null;
        }
      );
    } else {
      this.selectedUser = user.userId;
      this.restService.addProviderAgentToRequest(this.openedRowId, user.userId).subscribe(
        (res: string) => {
          this.notificationService.showNotification('Request assigned to agent successfully'); // Use the plain text message
          this.memberService.emitRefresh();
        },
        err => {
          this.notificationService.showNotification(err.error.message || 'Something went wrong', 'error');
          this.selectedUser = null;
        }
      );
    }
  }


  getAssignedAgent(request: any) {
    let loginId = this.memberService.getLoginUserId();
    if (request.serviceRequest.assignedProvider?.id == loginId) {
      return 'Slf';
    }
    else {
      if (request.serviceRequest.assignedProvider) {
        return request.serviceRequest.assignedProvider.firstName.charAt(0).toUpperCase() + "" + request.serviceRequest.assignedProvider.lastName.charAt(0).toUpperCase();
      }
      else
        return '';
    }
  }

  getAssignedAgentFullName(request: any) {
    if (request.serviceRequest.assignedProvider) {
      return request.serviceRequest.assignedProvider.firstName + " " + request.serviceRequest.assignedProvider.lastName;
    }
    else
      return '';
  }


  openPatientProfile(row: any): void {
    this.selectedPatient = row;
    this.memberService.setSelectedPatient(row);
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '800px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(PatientProfileComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  onRequestMoreDetails(row: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(RequestMoreDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  openAddPatientModal(row: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    // dialogConfig.data = {
    //   memberId: row.patientId
    // }by yashwanth
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(AddPatientComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        // this.getMemberList();
      }
    });
  }

  openRequestME(row: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = {
      memberId: row.patientId
    }
    const dialogRef = this.dialog.open(RequestMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  onFillMoreInfo(row: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '700px';
    dialogConfig.height = '630px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      memberId: row.patientId
    }
    const dialogRef = this.dialog.open(FillExtraInfoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Handle any actions after the image viewer is closed
      }
    });
  }

  onViewDocuments(doc: any) {
    console.log('doc', doc);

    // Use actual document path and name
    const fileUrl = doc.documentPath;
    const fileName = doc.documentOriginalName || doc.documentName;

    // Generate viewer URL
    const url = `/#/viewer?file=${encodeURIComponent(fileUrl)}&name=${encodeURIComponent(fileName)}`;

    // Open in new tab
    window.open(url, '_blank');
  }



  openMedicalEvidence(row: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '700px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(SubmitMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.memberService.emitRefresh();
      }
    });
  }

  getTurnAroundTime(row: any): string {
    if (!row.serviceRequest) {
      return '';
    }

    const createdOn = new Date(row.serviceRequest.createdon);
    const now = new Date();

    if (row.serviceRequest.status?.toLowerCase() !== 'received') {
      // Difference between createdOn and now
      return this.formatDuration(createdOn, now);
    } else {
      const lastUpdatedOn = new Date(row.serviceRequest.lastupdatedon);
      // Difference between createdOn and lastUpdatedOn
      return this.formatDuration(createdOn, lastUpdatedOn);
    }
  }

  private formatDuration(start: Date, end: Date): string {
    let msDiff = end.getTime() - start.getTime();

    if (msDiff < 0) {
      msDiff = 0;
    }

    let totalMinutes = Math.floor(msDiff / (1000 * 60));

    const years = Math.floor(totalMinutes / (60 * 24 * 365));
    totalMinutes -= years * 60 * 24 * 365;

    const months = Math.floor(totalMinutes / (60 * 24 * 30));
    totalMinutes -= months * 60 * 24 * 30;

    const weeks = Math.floor(totalMinutes / (60 * 24 * 7));
    totalMinutes -= weeks * 60 * 24 * 7;

    const days = Math.floor(totalMinutes / (60 * 24));
    totalMinutes -= days * 60 * 24;

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const parts = [];

    if (years) parts.push(`${years}y`);
    if (months) parts.push(`${months}m`);
    if (weeks) parts.push(`${weeks}w`);
    if (days) parts.push(`${days}d`);
    if (hours) parts.push(`${hours}hrs`);
    if (minutes || parts.length === 0) parts.push(`${minutes}m`);

    return parts.join(' ');
  }

  openedRowId: number | null = null;
  closingRowId: number | null = null;
  isAssignModalVisible: boolean = false;

  openAssignPopup(row: any): void {
    if (row.serviceRequest.status != 'RECEIVED') {
      this.userList = [];
      this.openedRowId = row.patientId;
      this.isAssignModalVisible = true;

      const loginUserId = this.memberService.getLoginUserId(); // Get logged-in userId

      this.restService.getProviderMapppedAgents().subscribe(res => {
        if (res) {
          let selfUser: any = null;

          // Find the logged-in user and modify name
          res.forEach((user: any) => {
            if (user.userId === loginUserId) {
              // user.firstName = 'Self';
              // user.lastName = 'Assign';
              selfUser = user;
            }
          });

          // Remove self user from original array if found
          if (selfUser) {
            res = res.filter((user: any) => user.userId !== loginUserId);
            res.unshift(selfUser); // Insert self user at beginning
          }

          this.userList = res;

          // Preselect assigned provider if any
          if (row.serviceRequest.assignedProvider) {
            this.selectedUser = row.serviceRequest.assignedProvider.id;
            console.log(row.serviceRequest.assignedProvider);
          }
        }
      }, err => {
        this.userList = [];
      });
    }
  }


  toggleAssignPopup(rowId: number): void {
    this.closingRowId = rowId;

    setTimeout(() => {
      if (this.openedRowId === rowId) {
        this.openedRowId = null;
      }
      this.closingRowId = null;
      this.isAssignModalVisible = false;
    }, 300); // Match with slideDown duration
  }


}
